<script>
	import Layout from '../../Stores/Layout';
	import Product from '../../Stores/Product';
	import Widget from './Widget.svelte';

	const menu = [
		{label: 'Beschrijving', scroll: 'description', icon: 'circle-info', active: true},
		{label: 'Voordelen', scroll: 'advantages', icon: 'circle-check'},
		{label: 'Nadelen', scroll: 'disadvantages', icon: 'circle-minus'},
		{label: 'Eigenschappen', scroll: 'attributes', icon: 'circle-ellipsis-vertical'},
		{label: 'Afbeeldingen', scroll: 'images', icon: 'circle-camera'},
		{
			label: 'Configureren!',
			icon: 'circle-right',
			style: 'attention',
			on_click: event => {
				Layout.product();
				Product.setStep(1);
			}
		}
	];
</script>

<Widget menu="{menu}" title="Info"/>